const config = () => ({
  token: '5SAPx2jl',
  options: {
    pageSize: 10,
    pageSizeTeaser: 3,
    pollInterval: 5000,
  },
  imageWidths: {
    mobile: 500,
    tablet: 800,
    desktop: 1000,
  },
  retryCounterMax: 5,
  retryInterval: 2000,
})

export type configType = ReturnType<typeof config>
export default config
